// ─────────────────────────────────────────────────────────────────────────────
//  LA RELANCE (A42, 13/10/2026) — « LE MESSAGE NE RENONCE PAS ». Mounir : « comment font les meilleures applications […] vas-y,
//  attention egress […] prouve-moi que tu as fait le meilleur travail de toutes les applications modernes ».
//
//  CŒUR PUR : aucun import, aucun effet, aucun état de module. Les décisions de la relance vivent ICI, en fonctions testées sous
//  horloge simulée (tests/le-message-ne-renonce-pas.test.mjs) ; le crochet (useMessageDelivery) ne fait que les câbler.
//
//  AVANT (lu dans le code le 13/10) : un message dont l'envoi échouait était marqué « Non envoyé · Renvoyer » (rouge) au PREMIER
//  échec, quel qu'il soit ; il repartait seul au démarrage et à l'évènement `online` du navigateur — UNE fois. Si cet essai-là
//  échouait (le navigateur annonce « en ligne » dès qu'il voit un routeur, avant qu'Internet ne réponde : MDN dit cet indicateur
//  « peu fiable par nature »), plus rien ne retentait avant le prochain `online` ou le prochain démarrage.
//
//  LA RÈGLE, APRÈS — celle de Signal (lu dans son code : IndividualSendJob, BackoffUtil), avec ce que la maison savait déjà faire :
//   · UN ÉCHEC SE CLASSE. « reseau » : aucune réponse (la requête n'est pas arrivée). « serveur » : le serveur a répondu, et c'est
//     passager (délai dépassé, base saturée, 5xx). Tout le reste est « definitif » : une RÈGLE a dit non — on ne frappe pas à une
//     porte fermée (Signal : seules les erreurs d'entrée-sortie se réessaient, jamais un rejet du serveur).
//   · UNE PANNE N'EST PLUS UN ÉCHEC : le message ATTEND (`relance`), calme, et repart seul — 2 s, 4 s, 8 s, 16 s, 32 s puis une
//     fois par minute au plus (cinq minutes quand c'est le serveur qui peine : on n'ajoute pas de charge à une base qui cale),
//     ± 25 % de hasard (les appareils d'une même panne ne reviennent pas tous à la même seconde), pendant 24 heures. Au-delà,
//     « Non envoyé · Renvoyer » : ressusciter en silence un message d'avant-hier serait une surprise, pas un service.
//   · L'ORDRE EST TENU : dans un fil, la file n'avance que par sa TÊTE. Un message écrit pendant qu'un autre attend prend la file
//     (`relance: "file"`) et ne le double jamais (Signal : une file par destinataire).
//  CE QUE ÇA COÛTE (la demande de Mounir : l'egress) : rien de plus quand tout va bien ; un essai sans réponse ne reçoit pas un
//   octet ; UN seul message par fil est en vol (la tête) ; aucun essai tant que le navigateur se dit hors ligne ; un refus définitif
//   n'est jamais réessayé par l'horloge. Pire cas, serveur en panne 24 heures, application ouverte : 300 essais par fil environ.
//   Et UN RÉESSAI NE RÉÉCRIT PAS LA CONVERSATION qu'un essai d'avant a déjà écrite (`convoEcrite`) : la réécrire ne change rien
//   en base mais diffuse deux messages temps réel qui ne portent rien (mesuré le 09/10, A30) — une fois par message au plus.
//  CE QUE LA MAISON FAIT DE MIEUX (T27, septembre) : quand le serveur DIT le délai (cadence), on prend le sien — eux le devinent.
// ─────────────────────────────────────────────────────────────────────────────

//  Les nombres de la règle (des constantes simples : pas de conteneur de module).
export const RELANCE_BASE_MS = 2000;               // le premier réessai : 2 s (Signal : 2^essai secondes)
export const RELANCE_PLAFOND_RESEAU_MS = 60000;    // sans réponse : une fois par minute au plus
export const RELANCE_PLAFOND_SERVEUR_MS = 300000;  // le serveur peine : une fois toutes les cinq minutes au plus
export const RELANCE_HASARD = 0.25;                // ± 25 % (Signal : 0,75 à 1,25)
export const RELANCE_VIE_MS = 86400000;            // 24 heures (Signal : la durée de vie de la tâche d'envoi)
export const RELANCE_ESSAI_MS = 30000;             // un essai sans réponse depuis 30 s est tenu pour une panne (la base coupe à 8 s)
export const SIGNAL_RECUL_MS = 10000;              // un signal qui s'est trompé n'est recru qu'après 10 s, puis le double
export const GESTE_APRES_MS = 3000;                // un nouvel envoi n'est un signal que si un message attend depuis 3 s au moins

// La NATURE d'un échec : null (pas d'erreur) · "reseau" (aucune réponse) · "serveur" (réponse passagère) · "definitif" (une règle).
//  Ce qui n'est pas reconnu est « definitif » : dans le doute, le comportement d'avant (le rouge, le bouton) — jamais une boucle.
export function natureDeLEchec(res) {
  const e = res && res.error;
  if (!e) return null;
  const code = String((e && e.code) || "");
  const msg = String((e && e.message) || (typeof e === "string" ? e : "") || "");
  const statut = Number(res && res.status);
  //  Le serveur a répondu, et c'est PASSAGER : la connexion à la base (08), une transaction à rejouer (40), les ressources (53),
  //  la requête annulée ou la base qui redémarre (57 — 57014 : le délai dépassé) ; PostgREST sans sa base (PGRST000 à 003) ;
  //  une cadence que le serveur n'aurait pas chiffrée (429xx).
  if (/^(08|40|53|57)[0-9A-Z]{3}$/.test(code) || /^PGRST00[0-3]$/.test(code) || /^429[0-9A-Z]{2}$/.test(code)) return "serveur";
  if (Number.isFinite(statut) && (statut >= 500 || statut === 408 || statut === 429)) return "serveur";
  //  AUCUNE réponse : supabase-js rend alors un code vide, le statut 0, et le message de l'exception du navigateur
  //  (Chrome « Failed to fetch », Safari « Load failed », Firefox « NetworkError… »). Le STATUT 0 suffit : lui seul ne dépend
  //  pas de la langue du navigateur (un WebKit ancien dit « La connexion Internet semble interrompue. »).
  if (!code && statut === 0) return "reseau";
  if (!code && !(statut > 0) && /failed to fetch|networkerror|network error|load failed|network request failed|fetch failed|err_network|err_internet|timed? ?out|aborted/i.test(msg)) return "reseau";
  return "definitif";
}

// Le DÉLAI avant le prochain essai : 2 s × 2^(essais − 1), plafonné, ± 25 %. `hasard` (0 à 1) est injecté pour les bancs.
export function delaiDeRelance(essais, nature, hasard) {
  const n = Math.max(1, Math.min(30, Math.floor(Number(essais)) || 1));
  const plafond = nature === "serveur" ? RELANCE_PLAFOND_SERVEUR_MS : RELANCE_PLAFOND_RESEAU_MS;
  const brut = Math.min(RELANCE_BASE_MS * Math.pow(2, n - 1), plafond);
  const h = (typeof hasard === "number" && Number.isFinite(hasard)) ? Math.min(1, Math.max(0, hasard)) : Math.random();
  return Math.round(brut * (1 - RELANCE_HASARD + 2 * RELANCE_HASARD * h));
}

// CE QUI SUIT UN ÉCHEC — le correctif à poser sur le message. Une panne : il attend (`relance`, l'instant du prochain essai, le
//  compte des essais). Une règle : le rouge, marqué `definitif` (l'horloge ne le reprendra pas). Trop vieux : le rouge.
//  L'instant que le serveur avait dit (`differe`, T27) est CONSOMMÉ par l'essai : il s'efface dans les trois issues — sans quoi la
//  collecte reprendrait le message pour « échu » à chaque passe. Et si l'essai a échoué À L'ÉCRITURE DU MESSAGE (`etape`, dit
//  par la passerelle), la conversation, elle, est écrite (`convoEcrite`) : les réessais ne la réécriront pas.
//  Une photo encore portée EN LIGNE dans le message (`data:` : son téléversement a échoué, c'est le repli de l'envoi) pèse des
//  mégaoctets : on ne la repousse pas seule à chaque essai sur un réseau qui peine — le bouton, comme avant A42.
export function apresEchec(message, res, now, hasard) {
  const nature = natureDeLEchec(res);
  const lourde = !!(message && message.image && typeof message.image.url === "string" && message.image.url.indexOf("data:") === 0);
  if ((nature !== "reseau" && nature !== "serveur") || lourde) return { failed: true, pending: false, definitif: true, relance: undefined, reessai: undefined, differe: undefined, convoEcrite: undefined };
  const age = now - Number((message && message.ts) || 0);
  if (!(Number.isFinite(age) && age >= 0 && age <= RELANCE_VIE_MS)) return { failed: true, pending: false, relance: undefined, reessai: undefined, differe: undefined, convoEcrite: undefined };
  const essais = Math.max(0, Math.floor(Number(message && message.essais)) || 0) + 1;
  const convoEcrite = ((res && res.etape === "message") || (message && message.convoEcrite === true)) ? true : undefined;
  return { failed: false, pending: false, definitif: undefined, differe: undefined, relance: nature, essais, reessai: now + delaiDeRelance(essais, nature, hasard), convoEcrite };
}

// Un de MES messages attend-il encore dans ce fil ? (alors le suivant prend la file derrière lui : l'ordre est tenu)
export function aUneRelance(convo, meId) {
  if (!convo || !meId || !Array.isArray(convo.messages)) return false;
  return convo.messages.some((m) => !!m && m.from === meId && typeof m.relance === "string" && !m.refused && m.imageLost !== true);
}

// L'INSTANT où l'horloge doit se réveiller : la tête de chaque file (son prochain essai, ou tout de suite si elle est mûre ou
//  périmée), et les messages que le serveur a différés (T27). null : rien n'attend, aucune horloge.
export function prochaineRelance(convos, meId, now) {
  if (!meId || !Number.isFinite(now)) return null;
  let t = null;
  const voir = (x) => { if (t === null || x < t) t = x; };
  for (const c of convos || []) {
    if (!c || !Array.isArray(c.messages) || !(c.participants || []).includes(meId)) continue;
    let tete = null;
    for (const m of c.messages) {
      if (!m || m.from !== meId || m.refused) continue;
      const ts = Number(m.ts || 0), age = now - ts;
      const vivant = Number.isFinite(age) && age >= 0 && age <= RELANCE_VIE_MS;
      //  Une relance qui ne partira plus — périmée, ou sa photo perdue au rechargement — est à RENDRE au geste du membre, tout
      //   de suite (relancesPerimees) : jamais un « Envoi en cours… » qui ne finit pas.
      if (typeof m.relance === "string" && (!vivant || m.imageLost === true)) { voir(now); continue; }
      if (m.imageLost === true) continue;
      if (typeof m.relance === "string") {
        if (!tete || ts < Number(tete.ts || 0) || (ts === Number(tete.ts || 0) && String(m.id) < String(tete.id))) tete = m;
        continue;
      }
      if (vivant && typeof m.differe === "number" && Number.isFinite(m.differe) && m.differe > 0) voir(Math.max(now, m.differe));
    }
    if (tete) {
      //  La tête est mûre à l'instant de son essai ("file" : tout de suite) ET pas avant celui que le serveur a dit (`differe`,
      //   T27) — la MÊME règle que la collecte (collectOutbox) : l'horloge ne se réveille jamais pour rien.
      const essai = tete.relance !== "file" && typeof tete.reessai === "number" && Number.isFinite(tete.reessai) ? tete.reessai : 0;
      const dit = typeof tete.differe === "number" && Number.isFinite(tete.differe) ? tete.differe : 0;
      voir(Math.max(now, essai, dit));
    }
  }
  return t;
}

// QUAND ARMER L'HORLOGE — ou null : on n'y touche pas. `plancher` : le serveur a dit « pas avant tel instant » (T27 : la cadence,
//  le rythme de la file) — la relance ne passe jamais devant. `echeance` : l'instant déjà armé (0 : aucune) — il n'y a qu'une
//  horloge, et on ne la réarme que pour PLUS TÔT.
export function instantDArmement(quand, plancher, echeance) {
  if (typeof quand !== "number" || !Number.isFinite(quand)) return null;
  const cible = Math.max(quand, Number.isFinite(plancher) ? plancher : 0);
  if (Number.isFinite(echeance) && echeance > 0 && cible >= echeance - 50) return null;
  return cible;
}

// Les relances qui NE PARTIRONT PLUS — périmées (plus de 24 heures, ou une heure impossible), ou dont la photo est perdue (l'aperçu
//  retiré du cache au rechargement : on n'envoie jamais un message amputé) : elles rendent la main au membre (« Non envoyé · Renvoyer »).
//  `toutes` : l'interrupteur est coupé — plus rien ne part seul, TOUT ce qui attendait rend la main.
export function relancesPerimees(convos, meId, now, toutes) {
  const out = [];
  if (!meId || !Number.isFinite(now)) return out;
  for (const c of convos || []) {
    if (!c || !Array.isArray(c.messages) || !(c.participants || []).includes(meId)) continue;
    for (const m of c.messages) {
      if (!m || m.from !== meId || typeof m.relance !== "string" || m.refused) continue;
      const age = now - Number(m.ts || 0);
      if (toutes === true || m.imageLost === true || !(Number.isFinite(age) && age >= 0 && age <= RELANCE_VIE_MS)) out.push({ convoId: c.id, id: m.id });
    }
  }
  return out;
}

// LE RECUL DES SIGNAUX. Un signal (le premier plan, la liaison rétablie, un nouvel envoi) fait essayer tout de suite. S'il s'est
//  TROMPÉ — l'essai qu'il a provoqué a échoué —, le suivant n'est cru qu'après 10 s, puis 20, 40… jusqu'à cinq minutes ; un essai
//  qui aboutit lui rend tout son crédit. Sans cela, une liaison temps réel qui clignote ferait essayer à chacun de ses retours.
export function reculDuSignal(attente, echec) {
  if (!echec) return 0;
  const a = Number(attente);
  return Math.min(RELANCE_PLAFOND_SERVEUR_MS, Math.max(SIGNAL_RECUL_MS, (Number.isFinite(a) && a > 0 ? a : 0) * 2));
}

// Depuis combien de temps (ms) le plus ancien de MES messages en attente dans ce fil a-t-il été écrit ? (-1 : aucun n'attend).
//  Un nouvel envoi derrière lui n'est un SIGNAL que passé trois secondes : deux messages tapés coup sur coup ne font pas deux
//  essais coup sur coup.
export function attenteDepuis(convo, meId, now) {
  if (!convo || !meId || !Array.isArray(convo.messages) || !Number.isFinite(now)) return -1;
  let plus = -1;
  for (const m of convo.messages) {
    if (!m || m.from !== meId || typeof m.relance !== "string" || m.refused || m.imageLost === true) continue;
    const age = now - Number(m.ts || 0);
    if (Number.isFinite(age) && age > plus) plus = age;
  }
  return plus;
}
